// src/components/Card.js
import React, { useRef } from 'react';
import './Card.css';

function Card({ card, addCardToDeck, isInDeck, showCardDetails }) {
  const imagePath = `${process.env.PUBLIC_URL}/assets/${card.card_image}`;
  const pressTimer = useRef(null);

  // 長押し開始
  const handleTouchStart = () => {
    clearTimeout(pressTimer.current);
    pressTimer.current = setTimeout(() => {
      // 🔔 振動（対応端末のみ）
      if (navigator.vibrate) {
        navigator.vibrate(50);
      }
      addCardToDeck(card);
    }, 500); // 500ms 長押し
  };

  // 指を離したらキャンセル
  const handleTouchEnd = () => {
    clearTimeout(pressTimer.current);
    pressTimer.current = null;
  };

  // 指を動かしたらキャンセル（スクロール対策）
  const handleTouchMove = () => {
    clearTimeout(pressTimer.current);
    pressTimer.current = null;
  };

  return (
    <li className={isInDeck ? 'grayscale' : ''}>
      <span>
        <img
          className="card-image"
          src={imagePath}
          alt={card.card_type_code}
          onClick={() => showCardDetails(card)} // タップ → 詳細
          onDoubleClick={() => addCardToDeck(card)} // PC ダブルクリック
          onTouchStart={handleTouchStart}  // 長押し開始
          onTouchEnd={handleTouchEnd}      // 離したら判定
          onTouchMove={handleTouchMove}   // スクロール中は無効
          onContextMenu={(e) => e.preventDefault()} // ブラウザのデフォルト動作廃止
        />
      </span>
    </li>
  );
}

export default Card;
